<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: laikt
 * @Date: 2020-11-09 10:06:31
 * @LastEditors: laikt
 * @LastEditTime: 2020-12-02 22:03:14
-->
<template>
  <div class="content-view-wrapper fullscreen">
    <!-- 头部 -->
    <header class="header">
      <!-- 头部左侧 -->
      <div class="header__left"></div>
      <div class="header__title">中 心 仓 视 频 回 放</div>
      <!-- 头部右侧 -->
      <div class="header__right">
        <div
          class="chat-tip"
          v-if="isFullscreen"
          @click="escFullscreen"
          title="退出全屏"
        >
          <i class="e6-icon-screen-half_line"></i>
        </div>
        <div class="chat-tip" @click="fullscreen" title="全屏" v-else>
          <i class="e6-icon-screen-full_line"></i>
        </div>
        <div
          class="vehicle-select"
          @click="handleToggleSelect"
          :title="selectVehicle ? selectVehicle : '选择摄像头及日期'"
        >
          <span>{{ selectVehicle ? selectVehicle : "选择摄像头及日期" }}</span>
          <i class="e6-icon-arrow-b_line"></i>
        </div>
      </div>
    </header>
    <div class="content-view">
      <!-- 监测点时间选择弹层 -->
      <transition name="fade">
        <div class="vehicle-select-content" v-show="showSelectPanel">
          <!-- 监测点时间弹层输入部分 -->
          <div class="select-input">
            <!-- 日期选择 -->
            <el-date-picker
              v-model="displayDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              popper-class="vehicle-tree-picker-panel"
              :editable="false"
              :clearable="false"
              :pickerOptions="pickerOptions"
            ></el-date-picker>
            <div class="title-wrap">
              <el-tabs
                type="border-card"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="视频查询" name="1"></el-tab-pane>
              </el-tabs>
            </div>
            <!-- 监测点名称搜索 -->
            <el-input
              placeholder="输入搜索"
              clearable
              v-model="filterText"
              @keyup.enter.native="handleFilterVehicleTree"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleFilterVehicleTree"
              ></el-button>
            </el-input>
          </div>
          <!-- 监测点树 -->
          <div
            class="tree-wrapper"
            v-loading="vehicleTreeLoading"
            element-loading-text="数据正在加载中..."
            element-loading-background="rgba(53, 84, 131, 0.8)"
          >
            <e6-tree
              ref="vehicleTree"
              :list.sync="vehicleTree"
              :is-radio="activeName === '0'"
              :is-check="activeName === '-1'"
              :issingleleaf="true"
              :is-open="true"
              :disabledNoCheck="true"
              :selectAndCheck="true"
              :before-change="handleBeforeChange"
              :chkfunc="getSingleData"
            ></e6-tree>
          </div>
          <div class="operate-wrapper">
            <el-button
              type="primary"
              :loading="searchVideoButtonLoading"
              @click="handleSearchVideo"
            >
              {{ searchVideoButtonLoading ? "加载中" : "查询" }}
            </el-button>
          </div>
        </div>
      </transition>
      <!-- 内容区域 -->
      <div class="content">
        <!-- 内容 -->
        <div class="container" v-show="containerStatus === 1">
          <div
            class="video-map-wrapper video-live"
            :style="{ height: isShow ? 'calc(100% - 330px)' : '100%' }"
          >
            <!-- 视频 -->
            <div class="video-map videos-wrap" v-show="videoMapStatus === 1">
              <ul class="video-dom-wrap">
                <li
                  v-for="(item, index) in videoUrl"
                  :key="index"
                  :class="videoCls"
                >
                  <div class="real-monit">
                    <div class="left-head">
                      <div class="route-info">
                        <p class="route-info-title" :title="item.cameraName">
                          {{ item.cameraName }}
                        </p>
                      </div>
                    </div>
                    <div class="video-wrapper real-video-wrap">
                      <e6-video
                        :ref="'video' + index"
                        :url="item.url"
                        :muted="false"
                        :hasAudio="true"
                        v-if="item.status === 'loaded'"
                      ></e6-video>
                      <div v-if="item.status === 'static'" class="empty-monit">
                        <img :src="monitIcon" alt="" />
                      </div>
                      <loading-video
                        v-else-if="item.status === 'loading'"
                      ></loading-video>
                      <div
                        v-else-if="item.status === 'loadError'"
                        class="load-error"
                      >
                        <i class="e6-icon-prohibit_line"></i>
                        <p>获取不到视频</p>
                        <a
                          href="javascript:void(0)"
                          @click="reGetVideo(item, index)"
                        >
                          重新加载
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 视频和地图 end -->
            <div class="video-map-status" v-show="videoMapStatus === 0">
              <img src="@/assets/images/video/video-help.png" />
              <p>您可以选择时间开始播放</p>
            </div>
            <div class="video-map-status" v-show="videoMapStatus === 2">
              <loading-video></loading-video>
            </div>
          </div>
          <div class="operate-video" v-if="isShow">
            <replay
              :checkedNode="checkedNode"
              :cameraList="cameraList"
              @queryVideo="queryVideo"
              @sliderChange="sliderChange"
              :time="theDay"
              :syncIsDisabled="syncIsDisabled"
              :videoMapStatus="videoMapStatus"
              @tabHandle="tabHandle"
              v-if="activeName === '-1'"
              ref="replay"
            />
            <temperature
              :cameraId.sync="cameraId"
              :timeList="timeList"
              :cameraList="cameraList"
              :checkedNode="checkedNode"
              :syncIsDisabled="syncIsDisabled"
              @sliderChange="temSliderChange"
              @queryTemVideo="queryTemVideo"
              :time="theDay"
              :videoMapStatus="videoMapStatus"
              ref="temperature"
              v-else
            >
              <el-radio-group v-model="cameraId" @change="radioChange">
                <el-radio
                  :label="camera.cameraId"
                  v-for="camera in cameraList"
                  :key="camera.cameraId"
                >
                  {{ camera.cameraName }}
                </el-radio>
              </el-radio-group>
            </temperature>
          </div>
        </div>
        <!-- 内容 end -->

        <!-- 未选择监测点 -->
        <div class="container-status" v-show="containerStatus === 0">
          <div class="video-nodata">
            <img
              src="../../../assets/images/pg-nodata-dark.png"
              alt="请在右侧选择需要查询摄像头和日期"
            />
            <p>请在右侧选择需要查询摄像头和日期</p>
          </div>
        </div>
        <!-- 未选择监测点 end -->

        <!-- 正在加载 -->
        <div class="container-status" v-show="containerStatus === 2">
          <loading-video></loading-video>
        </div>
        <!-- 正在加载 end -->
      </div>
      <!-- 内容区域 end -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import e6Tree from "e6-tree";
import loadingVideo from "@/components/video/loadingVideo";
import replay from "./replay";
import temperature from "./temperature";
import debounce from "lodash/debounce";
import monitIcon from "@/assets/images/video/monit-icon.png";
import api from "@/api/monitorCenter/warehouseVideo.js";

export default {
  name: "warehousePlaybackVideo",
  components: {
    loadingVideo,
    replay,
    temperature,
    e6Tree
  },
  data() {
    return {
      monitIcon,
      isFullscreen: false,
      isShow: false,
      activeName: "-1",
      containerStatus: 0, // 内容区域的显示状态： 0是默认， 1是正常， 2是loading
      checkedNode: {},
      filterText: "", // 筛选监测点树时的名称
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }, // 时间控件，限制今天以后的日期不能选
      theDay: moment().format("YYYY-MM-DD"),
      displayDate:
        this.$route.query.dangerousTime ||
        moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD"), // 侧边栏展示时的时间，
      // 视频和地图实现状态 0 是默认， 1是播放状态， 2是loading
      videoMapStatus: 0,
      // 展示当前监测点时间选择面板
      showSelectPanel: true,
      //   树load
      vehicleTreeLoading: false,
      vehicleTree: [], // 监测点树
      // 已选中的监测点信息
      selectVehicle: "",
      searchVideoButtonLoading: false,
      // videoUrl: {},
      videoUrl: [
        // {
        //   cameraId: "", //摄像头ID
        //   cameraName: "", //摄像头名称
        //   url: {
        //     flv: "",
        //     rtmp: ""
        //   } //视频地址
        // }
      ], // 播放视频的 url 地址
      currentAllLineVideos: [],
      tabType: "time", // 视频播放类型: time 按时间  file 按文件,
      sTime: "", // 时间日期开始时间
      eTime: "", // 时间日期结束时间
      selectedLineVideos: [], // 选中时间范围之内的视频文件
      allLineVideos: [], // 所有通道的视频
      currentLineVideo: 1, // 视频通道  默认选中通道 1
      timeLineRanges: [25200000, 43200000], // 时间轴范围,
      timeList: [],
      // 摄像头列表
      cameraList: [],
      // 当前摄像头
      cameraId: Infinity,
      syncIsDisabled: false,
      formatVideoL: 0, // 格式化的视频块数量 （1，2，4，6，9，12）
      // css
      monitStatusClass: {
        "0": "",
        "1": "success",
        "2": "warn",
        "3": "error",
        "4": "off",
        "5": "deheat"
      },
      isFromDangerous: false // 是否从中心仓危险明细页面跳转过来
    };
  },
  computed: {
    videoCls() {
      return "li-" + this.formatVideoL;
    }
  },
  created() {
    // this.fetchVehicleTree();
    this.getCameraTree();
    if (this.$route.query.cameraCode) {
      this.isFromDangerous = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      //监听全屏
      document.addEventListener(
        "fullscreenchange",
        () => {
          if (document.fullscreenElement) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
            this.showSelectPanel = false;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
            this.showSelectPanel = true;
          }
        },
        false
      );
      document.addEventListener(
        "msfullscreenchange",
        () => {
          if (document.msFullscreenElement) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
            this.showSelectPanel = false;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
            this.showSelectPanel = true;
          }
        },
        false
      );
      document.addEventListener(
        "mozfullscreenchange",
        () => {
          if (document.mozFullScreen) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
            this.showSelectPanel = false;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
            this.showSelectPanel = true;
          }
        },
        false
      );
      document.addEventListener(
        "webkitfullscreenchange",
        () => {
          if (document.webkitIsFullScreen) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
            this.showSelectPanel = false;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
            this.showSelectPanel = true;
          }
        },
        false
      );
    });
    // if (this.$route.query.cameraCode) {
    // this.checkedNode.id = this.$route.query.cameraCode;
    // console.log("checkedNode", this.checkedNode);
    // this.displayDate = moment(this.$route.query.startTime).format(
    //   "YYYY-MM-DD"
    // );
    // this.theDay = moment(this.$route.query.startTime).format("YYYY-MM-DD");

    // this.isShow = true;
    // this.activeName = "1";
    // this.showSelectPanel = false;
    // this.containerStatus = 1;
    // this.getPointAlarmPeriodList();
    // this.getCameraListByPointId();
    // this.$nextTick(() => {
    //   this.isShow &&
    //     this.$refs.temperature &&
    //     this.$refs.temperature.queryStorageHumitureDetails();
    //   setTimeout(() => {
    //     const nodes = this.$refs.vehicleTree.queryTreeNodeByID(
    //       this.$route.query.cameraCode
    //     );
    //     nodes.forEach(value => {
    //       console.log("ids", value);
    //       this.$refs.vehicleTree.setNodeCheck(value);
    //     });
    //     this.getSingleData();
    //   }, 1000);
    // });
    // }
  },
  methods: {
    tabHandle() {
      this.stopReplayVideo(
        this.cameraList.map(e => Number(e.id.split("_")[1]))
      );
      this.videoUrl = [];
      this.videoMapStatus = 0;
    },
    // 重新加载视频
    async reGetVideo(obj, index) {
      this.$set(this.videoUrl[index], "status", "loading");
      let time = "";
      let cameraId = "";
      this.$nextTick(() => {
        if (this.activeName === "0") {
          cameraId = obj.cameraId;
        } else {
          cameraId = this.cameraList[index] && this.cameraList[index].id;
          if (this.$refs.replay && this.$refs.replay.activeName === "first") {
            time = this.$refs.replay.syncTime;
          } else {
            time = obj.time;
          }
          this.syncIsDisabled = true;
        }

        api
          .replayVideo({
            reqList: [
              {
                beginTime: moment(time).format("YYYY-MM-DD HH:mm:ss"), //开始时间
                cameraId: Number(cameraId.split("_")[1]), //摄像头ID
                endTime: moment(this.displayDate)
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss") //结束时间
              }
            ]
          })
          .then(res => {
            if (
              res &&
              res.code === 1 &&
              Array.isArray(res.result) &&
              res.result.length > 0
            ) {
              this.$set(this.videoUrl, index, {
                cameraId: res.result[0].cameraId,
                cameraName: res.result[0].cameraName,
                realVideo: true,
                status: res.result[0].url ? "loaded" : "loadError",
                url: {
                  flv: res.result[0].url
                }
              });
            }
          })
          .catch(err => {
            this.$set(this.videoUrl[index], "status", "loadError");
            console.log(err);
          })
          .finally(() => {
            this.syncIsDisabled = false;
          });
      });
    },
    sliderChange: debounce(async function(value, camera, index) {
      console.log(
        value,
        camera,
        index,
        this,
        moment(
          moment(this.displayDate)
            .startOf()
            .valueOf() + this.cameraList[index].time
        ).format("YYYY-MM-DD HH:mm:ss")
      );
      console.log(this.cameraList);
      if (this.videoUrl[index] && this.videoUrl[index].status === "static") {
        return false;
      }
      this.$set(this.cameraList[index], "time", value);
      if (this.videoMapStatus === 1 && this.videoUrl.length > 0) {
        // this.videoMapStatus = 2;
        await this.stopReplayVideo([camera.id]);
        // this.$refs["video" + index].flvDestroy();
        this.$set(this.videoUrl[index], "status", "loading");
        this.$set(this.videoUrl[index], "url", { flv: "" });
        await this.temReplayVideo(index);
      }
    }, 600),
    temSliderChange: debounce(async function(value, camera, index) {
      console.log(
        value,
        camera,
        index,
        this,
        moment(
          moment(this.displayDate)
            .startOf()
            .valueOf() + this.cameraList[index].time
        ).format("YYYY-MM-DD HH:mm:ss")
      );
      this.$set(this.cameraList[index], "time", value);
      console.log(this.cameraList);
      if (this.videoMapStatus === 1 && this.videoUrl.length > 0) {
        this.videoMapStatus = 2;
        await this.stopReplayVideo([camera.cameraId]);
        // this.$refs["video" + index].flvDestroy();
        this.$set(this.videoUrl[index], "status", "loading");
        this.$set(this.videoUrl[index], "url", { flv: "" });
        await this.temReplayVideo(index);
      }
    }, 600),
    async temReplayVideo(index) {
      console.log(index, this.cameraList[index]);
      await api
        .replayVideo({
          reqList: [
            {
              beginTime: moment(
                moment(this.displayDate)
                  .startOf()
                  .valueOf() + this.cameraList[index].time
              ).format("YYYY-MM-DD HH:mm:ss"), //开始时间
              // cameraId: 12343 this.checkedNode.id, //摄像头ID
              cameraId:
                this.cameraList[index] &&
                (this.activeName === "0"
                  ? this.cameraList[index].cameraId
                  : this.cameraList[index].id), //摄像头ID
              endTime: moment(this.displayDate)
                .endOf("day")
                .format("YYYY-MM-DD HH:mm:ss") //结束时间
            }
          ]
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            const camera = res.result.map(e => {
              return {
                cameraId: e.cameraId,
                cameraName: e.cameraName,
                status: e.url ? "loaded" : "loadError",
                url: {
                  flv: e.url
                }
              };
            });
            camera.length && this.$set(this.videoUrl, index, camera[0]);
            this.videoMapStatus = 1;
          }
        });
    },
    async radioChange() {
      this.$refs.temperature.timeLineRange = 0;
      this.videoUrl[0] &&
        (await this.stopReplayVideo([this.videoUrl[0].cameraId]));
      this.videoMapStatus = 0;
      this.videoUrl.length === 1 && (await this.queryTemVideo());
    },
    async queryTemVideo(time) {
      if (this.videoMapStatus === 0) {
        console.log(!this.cameraId || this.cameraId === Infinity);
        if (!this.cameraId || this.cameraId === Infinity) {
          return this.$message.error("视频文件为空，请重新选择并播放");
        }
        await this.replayVideo(
          [this.cameraId],
          moment(
            moment(this.displayDate)
              .startOf()
              .valueOf() + time
          )
        );
      } else {
        console.log(this.videoUrl[0]);
        this.stopReplayVideo([this.cameraId]);
        this.videoUrl = [];
        // this.$refs.vehicleTree.setAllNodeCheck(false);
        this.containerStatus = 0;
        this.videoMapStatus = 0;
        this.isShow = false;
        this.showSelectPanel = !this.showSelectPanel;
      }
    },
    queryVideo(time) {
      let ids = this.$refs.vehicleTree.getAllNodes().ids;
      ids = ids.map(v => {
        return Number(v.split("_")[1]);
      });
      if (this.videoMapStatus === 0) {
        if (ids.length > 16) {
          return this.$message.warning("最多支持16个摄像头");
        }
        this.replayVideo(ids, time);
      } else {
        this.stopReplayVideo(ids);
        this.videoUrl = [];
        this.containerStatus = 0;
        this.videoMapStatus = 0;
        this.isShow = false;
        this.showSelectPanel = !this.showSelectPanel;
      }
    },
    // 获取部门-仓库-摄像头树形结构选择  isSelOutTemp=1（只看脱温）
    getCameraTree() {
      api.getCameraTree({ onlineStatus: this.activeName }).then(res => {
        if (res && res.code === 1 && res.result) {
          this.vehicleTree = res.result;
          // 危险事件明细跳转过来
          if (this.$route.query.cameraCode) {
            this.$nextTick(() => {
              // 选中车辆树中的节点
              let nodes = this.$refs["vehicleTree"].queryTreeNodeByID(
                this.$route.query.cameraCode
              );
              if (Array.isArray(nodes)) {
                nodes.forEach(n => {
                  this.$refs["vehicleTree"].setNodeCheck(n, true);
                  this.selectVehicle = nodes[0].label;
                });
              } // 选中
              this.handleSearchVideo();
            });
          }
        }
      });
    },
    // 摄像头开始回放视频（支持批量） cameraId type ：[],number
    replayVideo(cameraId = [this.checkedNode.id], time = "") {
      this.syncIsDisabled = true;
      const reqList = cameraId.map((e, index) => {
        return {
          beginTime: time
            ? moment(time).format("YYYY-MM-DD HH:mm:ss")
            : moment(
                moment(this.displayDate)
                  .startOf()
                  .valueOf() + this.cameraList[index].time
              ).format("YYYY-MM-DD HH:mm:ss"),
          cameraId: e, //摄像头ID
          endTime: moment(this.displayDate)
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss") //结束时间
        };
      });
      api
        .replayVideo({
          reqList
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            if (Array.isArray(res.result) && res.result.length > 0) {
              if (res.result.every(e => !e.url)) {
                return this.$message.error("视频文件为空，请重新选择并播放");
              }
              if (this.activeName === "-1") {
                this.videoUrl = this.cameraList.map(value => {
                  // console.log(res.result.find(e => e.cameraId === value.id));
                  // console.log(
                  //   res.result.some(e => {
                  //     e.cameraId === value.id;
                  //   })
                  // );
                  if (
                    res.result.find(
                      e => e.cameraId === Number(value.id.split("_")[1])
                    )
                  ) {
                    const camera = res.result.find(
                      e => e.cameraId === Number(value.id.split("_")[1])
                    );
                    return {
                      cameraId: camera.cameraId,
                      cameraName: camera.cameraName,
                      status: camera.url ? "loaded" : "loadError",
                      url: {
                        flv: camera.url
                      }
                    };
                  } else {
                    return {
                      cameraId: Number(value.id.split("_")[1]),
                      cameraName: value.label,
                      status: "static",
                      url: {
                        flv: ""
                      }
                    };
                  }
                });
              } else {
                this.videoUrl = res.result.map(e => {
                  return {
                    cameraId: e.cameraId,
                    cameraName: e.cameraName,
                    status: e.url ? "loaded" : "loadError",
                    url: {
                      flv: e.url
                    }
                  };
                });
              }
              this.formatVideoL = this.formatLen(this.videoUrl.length);
              // 格式化视频dom块（增加伪块）
              for (let i = 0; i < this.formatVideoL; i++) {
                // 重新添加空项目
                if (this.videoUrl.length <= i) {
                  this.videoUrl.push({
                    status: "static",
                    url: ""
                  });
                }
              }
              this.videoMapStatus = 1;
            } else {
              this.$message.error("暂无视频");
              this.videoMapStatus = 0;
            }
          }
        })
        .catch(() => {
          this.videoMapStatus = 0;
        })
        .finally(() => {
          this.syncIsDisabled = false;
        });
    },
    formatLen(len) {
      if (len > 2) {
        if (len < 5) {
          return 4;
        }
        if (len < 7) {
          return 6;
        } else if (len < 10) {
          return 9;
        } else if (len < 13) {
          return 12;
        } else {
          return 16;
        }
      } else {
        return len;
      }
    },
    // 停止播放
    async stopReplayVideo(ids) {
      await api.stopReplayVideo({ cameraIdList: ids }).then(res => {
        if (res && res.code === 1 && res.result) {
          console.log(res);
        }
      });
    },
    //根据监测点id+时间段，查询各类报警时段列表
    getPointAlarmPeriodList() {
      this.searchVideoButtonLoading = true;
      console.log(this.checkedNode);
      api
        .getPointAlarmPeriodList({
          beginTime: moment(this.displayDate)
            .startOf("day")
            .valueOf(),
          endTime: moment(this.displayDate)
            .endOf("day")
            .valueOf(),
          pointId: this.checkedNode.id
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            const timeList =
              res.result.length > 0
                ? res.result.map(value => {
                    return {
                      ...value,
                      startTime: moment(this.displayDate + " " + value.bTimeStr)
                        .startOf("minute")
                        .valueOf(),
                      endTime: moment(this.displayDate + " " + value.eTimeStr)
                        .startOf("minute")
                        .valueOf(),
                      className: this.monitStatusClass[value.monitStatus]
                    };
                  })
                : [];
            this.timeList = timeList.sort((a, b) => {
              return a.startTime - b.startTime;
            });
            if (this.timeList.length === 0) {
              // this.$message.error("暂无数据");
              // this.timeList = [
              //   {
              //     startTime: moment(this.displayDate)
              //       .startOf("day")
              //       .valueOf(),
              //     endTime: moment(this.displayDate)
              //       .endOf("day")
              //       .valueOf(),
              //     monitStatus: 4,
              //     className: "off"
              //   }
              // ];
            }
            console.log("timeList", this.timeList);
            this.searchVideoButtonLoading = false;
          }
        });
    },
    // 根据选择的监测点ID获取其绑定的摄像头列表
    getCameraListByPointId() {
      this.searchVideoButtonLoading = true;
      api
        .getCameraListByPointId({ pointId: this.checkedNode.id })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.cameraList = res.result;
            if ((this.cameraId = res.result.length)) {
              this.cameraId =
                res.result.length > 0 ? res.result[0].cameraId : "";
            } else {
              this.$message.error("监测点暂无摄像头");
            }
            console.log(res);
          }
        })
        .finally(() => {
          this.searchVideoButtonLoading = false;
        });
    },

    // 全屏
    fullscreen() {
      var element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
      // this.$store.dispatch("common/setFullScreenAct", true);
      this.isFullscreen = true;
      this.showSelectPanel = false;
    },
    // 退出全屏
    escFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      // this.$store.dispatch("common/setFullScreenAct", false);
      this.isFullscreen = false;
      this.showSelectPanel = true;
    },
    // 切换视频播放类型
    handleChangeVideoType(value) {
      this.tabType = value;
    },
    // 类型切换
    async handleClick() {
      await this.fetchVehicleTree();
      if (this.videoUrl.length > 0) {
        await this.stopReplayVideo(this.videoUrl.map(e => e.cameraId));
      }
      this.cameraList = [];
      this.videoUrl = [];
      this.videoMapStatus = 0;
      this.selectVehicle = "";
      this.isShow = false;
    },
    // 获取部门-仓库-摄像头树形结构选择  isSelOutTemp=1（只看脱温）
    async fetchVehicleTree() {
      try {
        this.vehicleTreeLoading = true;
        let res = await api[
          this.activeName === "0"
            ? "getStorageLocationPointTree"
            : "getCameraTree"
        ]();
        if (res.code === 1 && res.result && Array.isArray(res.result)) {
          this.vehicleTree = res.result;
          // 危险事件明细跳转过来
          if (this.$route.query.cameraCode) {
            this.$nextTick(() => {
              // 选中车辆树中的节点
              let nodes = this.$refs["vehicleTree"].queryTreeNodeByID(
                this.$route.query.cameraCode
              );
              if (Array.isArray(nodes)) {
                nodes.forEach(n => {
                  this.$refs["vehicleTree"].setNodeCheck(n, true);
                  this.selectVehicle = "已选择：1";
                });
              } // 选中
              this.handleSearchVideo();
            });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.vehicleTreeLoading = false;
      }
    },
    // 切换视频倍速
    handleChangeVideoSpeed() {
      this.changeVideoSpeed({
        ...this.directiveParams,
        playType: 3,
        playSpeed: this.videoSpeed
      });
    }, // 切换视屏倍速
    async changeVideoSpeed(params) {
      try {
        await api.changeVideoSpeed(params);
      } catch (error) {
        console.log(error);
      }
    },
    // 监测点树筛选
    handleFilterVehicleTree() {
      this.$refs.vehicleTree.queryTreeNodeByName(this.filterText);
    },
    // 点击监测点树节点选中之前触发的方法
    handleBeforeChange(...arg) {
      let { next } = arg[0];
      next();
      // 点击节点之前做判断，点击的节点是上次点击的，还是新节点，根据监测点 id 判断
    },
    // 树选中
    getSingleData(node) {
      if (node) {
        this.checkedNode = node;
      }
      const data = this.$refs.vehicleTree.getAllNodes().data;
      const dataLength = [...new Set(data.map(e => e.id))];
      console.log(data, dataLength);
      if (dataLength.length > 1) {
        this.selectVehicle = "已选择：" + dataLength.length;
      } else if (dataLength.length === 1) {
        this.selectVehicle = data[0].label;
      } else if (dataLength.length === 0) {
        this.selectVehicle = "";
      }
      // this.$set(this.checkedNode, "info", "(正在获取流量中...)");
    },
    // 时间监测点选择列表切换
    handleToggleSelect() {
      this.showSelectPanel = !this.showSelectPanel;
      // this.showSelectPanel && this.fetchVehicleTree();
      // this.isShow = false;
    },
    // 查询视频按钮
    async handleSearchVideo() {
      // 未选择监测点
      let { ids } = this.$refs.vehicleTree.getAllNodes();
      if (!ids[0]) return this.$message.info("请选择摄像头");
      this.videoSpeed = 1; // 初始化播放倍速
      this.containerStatus = 1;
      this.theDay = this.displayDate;
      if (this.videoMapStatus === 1) {
        this.$confirm("当前有正在播放的视频，是否仍要查询新的视频回放？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            console.log(this.videoUrl);
            await this.stopReplayVideo(this.videoUrl.map(e => e.cameraId));
            this.videoUrl = [];
            this.videoMapStatus = 0;
            await this.resetQuery();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        await this.resetQuery();
      }
    },
    async resetQuery() {
      if (this.activeName === "0") {
        await this.getPointAlarmPeriodList();
        await this.getCameraListByPointId();
        this.isShow = true;
        this.$nextTick(() => {
          this.isShow &&
            this.$refs.temperature &&
            this.$refs.temperature.queryStorageHumitureDetails();
        });
      } else {
        let { data } = this.$refs.vehicleTree.getAllNodes();
        this.cameraList = data.map(e => {
          return {
            ...e,
            time: 0
          };
        });
        let obj = {};
        this.cameraList = this.cameraList.reduce((item, next) => {
          obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
          return item;
        }, []);
        this.isShow = true;
      }
      this.showSelectPanel = !this.showSelectPanel;
      this.$nextTick(() => {
        // 从危险事件明细表跳转过来直接查询视频回放
        if (this.isFromDangerous) {
          let time = moment(this.$route.query.dangerousTime).valueOf();
          this.queryVideo(time);
        }
      });
    },
    // 视屏下载
    handleVideoPick() {
      /* 视频下载时间
       * 开始时间默认 当前所选时间段的开始时间
       * 结束时间默认 当前所选时间段的开始时间后5分钟
       */
      let [sTime] = this.timeLineRange;
      sTime = this.searchData + sTime;
      this.downloadTime = [sTime, sTime + 5 * 60 * 1000];
      this.$refs.pickBox.setVehicle(this.selectedVehicleNodeInfo.id);
      this.visible = true;
    },
    // 格式化提示时间
    formatTooltip(value) {
      let time = moment()
        .startOf("days")
        .valueOf();

      return moment(time + value).format("HH:mm:ss");
    },
    // 修改时间
    timeLineRange(val) {
      let [sTime, eTime] = val;
      this.sTime = this.searchData + sTime;
      this.eTime = this.searchData + eTime;

      if (this.playType === 0) {
        // 切断视频播放
        if (this.videoMapStatus === 1) {
          this.videoMapStatus = 0;
          this.cutOffVideo();
        }

        if (this.videoMapStatus === 2) {
          this.videoMapStatus = 0;
        }
      }

      /* 视频下载弹框开始/结束时间联动
       * 开始时间默认 当前所选时间段的开始时间
       * 结束时间默认 当前所选时间段的开始时间后5分钟
       */
      this.downloadTime = [this.sTime, this.sTime + 5 * 60 * 1000];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/videoCommon.scss";
@import "@/assets/styles/videoMonit.scss";
$sidebarwidth: 240px;
$lightfont: #46bfea;
$normalfont: #9297a6;
.content-view-wrapper {
  padding: 0 !important;
  height: 100%;
  background-image: url("../../../assets/images/video/video_report_bg.png");
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

// 头部
.header {
  display: flex;
  background: #080c23;
  &__title {
    width: 2.3rem;
    height: 0.45rem;
    margin: 0;
    color: $lightfont;
    line-height: 0.45rem;
    text-align: center;
    font-size: 0.24rem;
    font-weight: normal;
  }
  &__left {
    flex: 1;
    // background: url("../../../assets/images/video/title_left.png");
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-size: cover;
    .play-speed {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 0.2rem;
      height: 100%;
      color: $lightfont;
      font-size: 14px;
      /deep/ .el-select {
        width: 0.7rem;
        border: 1px solid $lightfont;
        border-radius: 5px;
        margin-left: 0.1rem;
        .el-input__inner {
          background-color: #163453;
          border: 1px solid $lightfont;
          color: $lightfont;
        }
        .el-input__suffix {
          color: $lightfont;
        }
        .el-select__caret {
          color: $lightfont;
        }
      }
    }
  }
  &__right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // background: url("~/assets/images/video/title_right.png");
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-size: cover;
    .vehicle-select {
      display: flex;
      justify-content: space-between;
      width: 1.52rem;
      height: 0.12rem;
      padding: 0.07rem 0.08rem 0.07rem 0.08rem;
      margin-right: 0.2rem;
      color: #3185a3;
      font-size: 0.12rem;
      line-height: 0.12rem;
      border: 1px solid $lightfont;
      background-color: #173248;
      border-radius: 3px;
      cursor: pointer;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}

// 布局
.content-view {
  height: calc(100% - 0.45rem);
  position: relative;
  // 内容
  .content {
    height: 100%;
    // position: relative;
    // width: calc(100% - #{$sidebarwidth});
  }
  // 侧边栏
  .sidebar {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: $sidebarwidth;
    height: 100%;
    border-left: 1px solid #edf0f5;
    box-sizing: border-box;
  }
  // 监测点日期选择
  .vehicle-select-content {
    z-index: 999;
    width: 356px;
    position: absolute;
    top: 0;
    right: 0.2rem;
    bottom: 0.2rem;
    background-color: #091e4a;
    border-radius: 4px;
    transition: all 1s;
    transform-origin: 50% 0;
    transform: scale(1, 1);
    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
      transform: scale(1, 0);
    }
    &::before {
      content: "";
      position: absolute;
      top: -0.14rem;
      right: 0.8rem;
      width: 0;
      height: 0;
      border: 0.07rem solid transparent;
      border-bottom-color: #091e4a;
    }
    // 监测点搜索
    .select-input {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 10px 0 10px;
      /deep/ .el-input {
        width: 100%;
        height: 32px;
        color: $lightfont;
        margin-bottom: 10px;
        .el-input__inner {
          height: 32px;
          line-height: 32px;
          color: $lightfont;
          background-color: #0e2b57;
          border-color: #215e8a;
          &::placeholder {
            color: #3185a3;
          }
        }
        .el-input__prefix {
          color: $lightfont;
        }
        .el-input-group__append {
          background-color: #194974;
          border-color: #215e8a;
          color: $lightfont;
        }
      }
    }
    // 监测点下拉树
    .tree-wrapper {
      height: calc(100% - 94px - 46px - 37px);
      padding-left: 10px;
      .new_tree_content_wrap {
        /deep/.new_treeDemoBackground {
          .new_tree {
            background-color: #091e4a;
            // 树叶子文字颜色
            div {
              a {
                color: rgba($color: #ffffff, $alpha: 0.5);
              }
            }
            .dynamic-content {
              // 滚动条样式
              &::-webkit-scrollbar-thumb {
                background-color: #0c336e;
                outline: 2px solid #0c336e;
                border: 2px solid #0c336e;
              }
              &::-webkit-scrollbar-track-piece {
                background-color: #091e4a;
              }
              &::-webkit-scrollbar-corner {
                background-color: #091e4a;
              }
            }
          }
        }
      }
      .e6-icon-truck_fill,
      .e6-icon-acc_fill {
        color: #c0c4cc;
        &.active {
          color: #67c23a;
        }
      }
    }
    .operate-wrapper {
      height: 46px;
      background-color: #0a2353;
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/ .el-button {
        background-color: #164271;
        color: $lightfont;
        border-color: $lightfont;
        &:hover {
          color: #164271;
          background-color: $lightfont;
        }
      }
    }
  }
}

.tree-wrapper {
  /deep/ .new_tree_content_wrap .new_tree div div:hover {
    background-color: rgba(53, 84, 131, 0.8);
  }
}
// 内容
.content {
  .container {
    height: 100%;
  }

  .container-status {
    width: 100%;
    height: 100%;
    background-color: #080c23;
    /deep/ .e6-nodata {
      .e6-nodata-text {
        color: #1f4287;
      }
    }
  }

  .video-map-wrapper {
    position: relative;

    .video-map {
      display: flex;
      width: 100%;
      height: 100%;
    }
    .video-wrapper,
    .map-wrapper {
      width: 50%;
      height: 100%;
      position: relative;
    }

    .video-wrapper {
      background-color: #000;
      /deep/ .e6-video {
        width: 100%;
        height: 100%;
        background-color: #000;
      }
      /deep/ .el-select {
        width: 70px;
        height: 26px;
        outline: none;
        border-radius: 13px;
        font-size: 12px;
        color: #fff;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10;
        .el-input__inner {
          padding-left: 10px;
          padding-right: 10px;
          background-color: rgba(0, 0, 0, 0.4);
          color: #fff;
        }
      }
    }

    .map-wrapper {
      .vehicle-position {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 36px;
        font-size: 12px;
        color: $normalfont;
        padding-left: 15px;
        background-color: #091e49;
        line-height: 36px;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
        box-sizing: border-box;
      }
    }

    .video-map-status {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #1f4287;
      background-color: #080c23;
      overflow: hidden;
      p {
        font-size: 14px;
        margin-top: 30px;
      }
    }
  }
  // 视频操作区
  .operate-video {
    position: relative;
    height: 330px;
    background-color: #081939;
    z-index: 300;
    .tab-group {
      display: flex;
      align-items: center;
      height: 40px;
      font-size: 14px;
      color: $normalfont;
      border-bottom: 1px solid #123166;
      background-color: rgba(#0a224b, 0.4);
      box-sizing: border-box;
    }
    .tab-item {
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      cursor: pointer;
      &:first-child {
        margin-left: 15px;
        margin-right: 40px;
      }
      &.active {
        color: $lightfont;
        border-bottom: 2px solid $lightfont;
      }
    }

    .video-download {
      position: absolute;
      right: 10px;
      color: $lightfont;
      font-size: 16px;
      i {
        cursor: pointer;
      }
      i:nth-child(1) {
        margin-right: 10px;
      }
      // .history {
      //   border-color: #849bbd;
      //   background-color: #849bbd;
      // }
    }
  }
}

// 视频操作区
.operate-video {
  font-size: 14px;
  color: $normalfont;
  // color: #606266;

  .operate-wrapper {
    height: calc(100% - 70px);
  }
  .operate-time {
    min-width: 900px;
    padding: 0 50px;
    font-size: 14px;
    color: $normalfont;
    & > li {
      margin-top: 30px;
      & > span {
        display: block;
        width: 38px;
      }
    }

    .line-wrapper {
      display: flex;
      align-items: center;
      .line-item {
        height: 28px;
        padding: 0 14px;
        margin-right: 10px;
        color: $normalfont;
        line-height: 28px;
        // background-color: #edf0f5;
        background-color: rgba(#535e75, 0.4);
        border: 1px solid #535e75;
        border-radius: 14px;
        cursor: pointer;
        &.active {
          color: #fff;
          border-color: $lightfont;
          background-color: rgba($lightfont, 0.3);
        }
      }
      .no-line {
        height: 28px;
        line-height: 28px;
        color: #888;
      }
    }

    .play-speed {
      margin-left: 20px;
      margin-right: 10px;
    }

    .video-range {
      position: relative;
      height: 100%;
      .video-item {
        position: absolute;
        top: 0;
        height: 100%;
        background-color: #ffaa00;
        border-radius: 5px;
      }
    }
    .time-line-wrapper {
      position: relative;
      /deep/ .lo-slider-time {
        background-color: #08193b;
        /deep/ .el-slider__runway {
          background-color: #21304d;
          border-color: #2d3e64;
          border-width: 1px;
          border-radius: unset;
        }
        /deep/ .el-slider__footer {
          background-color: #08193b;
          .time-item {
            color: $normalfont;
            &::before {
              background-color: #2e3e63;
            }
          }
        }
        .el-slider__button-wrapper {
          width: 9px;
          background-color: unset;
          .tooltip {
            color: $lightfont;
          }
          .tooltip-btn {
            background-color: unset;
          }
        }
        .tooltip-left {
          background: url("../../../assets/images/video/left.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .tooltip-right {
          background: url("../../../assets/images/video/right.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
      }

      .legend-wrapper {
        position: absolute;
        right: 0;
        top: -20px;
        display: flex;
        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .has-video {
          .square {
            background-color: #ffaa00;
          }
        }
        .no-video {
          margin-left: 20px;
          .square {
            border: 1px solid rgba(126, 151, 183, 0.25);
            background-color: #21304d;
            box-sizing: border-box;
          }
        }
        .square {
          height: 12px;
          width: 12px;
          margin-right: 5px;
        }
      }
    }
    .select-time-range {
      position: relative;
      display: flex;
      align-items: center;
      .el-date-editor {
        width: 150px;
      }
      /deep/ .el-input__inner {
        color: $normalfont;
        border-color: #46bfea;
        background-color: rgba(70, 191, 234, 0.2);
      }
      /deep/ .el-input__suffix {
        color: $normalfont;
      }
    }
    .el-button {
      margin-left: 38px;
      width: 100px;
      height: 36px;
    }
    /deep/ .el-button--primary {
      border-color: #46bfea;
      background-color: rgba(70, 191, 234, 0.2);
    }
    .button-cancle {
      color: $normalfont;
      background-color: rgba(#535e75, 0.4);
      border: 1px solid #535e75;
    }
  }
  .operate-file {
    height: 100%;
    overflow: auto;
  }
  .file-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px;
    .file-card {
      margin: {
        right: 10px;
        bottom: 10px;
      }
      width: 260px;
      height: 62px;
    }
    .file-card-item {
      position: relative;
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      border-radius: 5px;
      background-color: #162c5b;
      &.playing {
        border: 2px solid $lightfont;
        box-shadow: 0px 0px 3px $lightfont;
        &:before {
          content: "";
          position: absolute;
          top: -2px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          z-index: 5;
          background-color: #fff;
          animation: mymove 4s infinite;
          box-shadow: 0 0 3px 3px rgb(117, 219, 255);
        }
      }
      @keyframes mymove {
        0% {
          top: -2px;
          left: -3px;
        }
        25% {
          top: -2px;
          left: 256px;
        }
        50% {
          top: 63px;
          left: 256px;
        }
        75% {
          top: 63px;
          left: -3px;
        }
        100% {
          top: -3px;
          left: -3px;
        }
      }
      .channal {
        width: 30px;
        padding: 15px 5px;
        color: $normalfont;
        text-align: center;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .bg-odd {
        background-color: #324fb7;
      }
      .bg-even {
        background-color: #096a9f;
      }
      .time {
        width: 175px;
        height: 40px;
        padding: 11px;
        color: #fff;
        p:nth-child(1) {
          margin-bottom: 5px;
        }
      }
      .play-status {
        width: 60px;
        line-height: 62px;
        color: $lightfont;
        font-size: 28px;
        text-align: center;
        i {
          cursor: pointer;
        }
      }
    }
  }
}

// 侧边栏
.sidebar {
  .title {
    height: 40px;
    padding-left: 10px;
    border-bottom: 1px solid #edf0f5;
    font-size: 16px;
    line-height: 38px;
    color: #303133;
    background-color: #fafbfc;
    box-sizing: border-box;
  }
  .tree-wrapper {
    height: calc(100% - 40px - 124px);
    background-color: #fff;
    .e6-icon-truck_fill,
    .e6-icon-acc_fill {
      color: #c0c4cc;
      &.active {
        color: #67c23a;
      }
    }
  }
  .operate-wrapper {
    height: 124px;
    text-align: center;
    background-color: #fafbfc;
    .el-input {
      width: 220px;
      margin-top: 10px;
    }
    .el-button--primary {
      margin-top: 10px;
    }
  }
  // .video-live /deep/ .route-info /deep/ p.route-info-title {
  //   border-radius: 13px !important;
  //   background-color: rgba(0, 0, 0, 0.6) !important;
  //   color: #fff !important;
  // }
}
</style>

<style lang="scss">
.vehicle-tree-picker-panel {
  left: auto !important;
  right: 5px;
}
.pick-box.detail-content-pick {
  z-index: 1000;
}
.video-quality-selector {
  // background: transparent;
  .el-select-dropdown__wrap {
    .el-select-dropdown__list {
      padding: 0px;
      // background-color: #000;
      // .el-select-dropdown__item {
      //   padding: 0 12px;
      //   height: 26px;
      //   line-height: 26px;
      //   font-weight: normal;
      //   background: transparent;
      //   color: #fff;
      //   &:hover {
      //     background: #32b8e8;
      //   }
      // }
    }
  }
  .popper__arrow {
    top: -7px !important;
  }
  .load-error a {
    font-size: 16px;
  }
}
</style>
<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
  height: 0;
}
.video-live .right-part .title-wrap {
  width: 100%;
  padding: 0;
}
.title-wrap {
  .el-tabs--border-card {
    border: 0;
  }
  /deep/.el-tabs__nav.is-top {
    display: flex;
    width: 100%;
    .el-tabs__item {
      height: 36px;
      background-color: #0f2e5a;
      border: 0;
      box-sizing: border-box;
      margin: 0;
      color: #46bfea;
      font-weight: normal;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-tabs__item.is-active {
      // border-top: 2px solid #46bfea;
      background-color: #091e4a;
      margin: 0;
      position: relative;
    }
    .el-tabs__item.is-active::after {
      content: "";
      display: inline-block;
      height: 2px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #46bfea;
    }
  }
  /deep/.el-tabs--border-card > .el-tabs__content {
    display: none;
  }
  .el-tabs--top /deep/.el-tabs__item {
    width: 100%;
    text-align: center;
  }
}
.chat-tip {
  border: 1px solid #46bfea;
  border-radius: 3px;
  margin-right: 10px;
  height: 0.12rem;
  width: 0.12rem;
  padding: 0.07rem 0.08rem 0.07rem 0.08rem;
  display: flex;
  justify-content: center;
  align-items: center;
  > i {
    font-size: 20px;
    color: #46bfea;
  }
}
.video-nodata {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  & > img {
    display: block;
    margin: 0 auto;
  }
  & > p {
    font-size: 14px;
    line-height: 14px;
    color: #256ab1;
    text-align: center;
    margin: 10px 0;
  }
}
</style>
